import { Component, OnInit } from '@angular/core';
import { ReceiptService } from '../../../../services/receipt.service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { DataTransferService } from '../../../../services/DataTransferService';
import { Router } from '@angular/router';
//import { LocalApiConnectorService } from '../../../../services/local-api-connector.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { find, map, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../../services/endpoint.config.service';
import { LocationService } from '../../../../services/location.service';
import { TranslateService } from '@ngx-translate/core';
import { forEach } from 'angular';
declare let $: any;

@Component({
  selector: 'search-receipt',
  templateUrl: './search-receipt.component.html',
  styleUrls: ['./search-receipt.component.scss']
})
export class SearchReceiptComponent implements OnInit {
  searchTerm: any;
  isCanceled: boolean = false;
  receiptTypeId: number = 0;
  fieldName: any = 'ReceiptNumber';
  receipts: any = [];
  openClose = false;
  canCancelOutboundReceipts: boolean;
  public pagger: number = 0;
  pagesContainer: any;
  pageCount: number = 0;
  base64Output : string;
  isSpotter: boolean = false;
  isOpen: boolean = false;
  linkShipments: LinkShipments[] = [];
  
 

  sss: any;

  prepareSearchObject(take: number, skip: number, fieldName: string, startsWith: string, receiptTypeId: number, isCancelled: boolean, numberOfDays: number) {
    var searchObject = { skip: skip, take: take, fieldName: fieldName, startsWith: startsWith, receiptTypeId: receiptTypeId, isCancelled: isCancelled, numberOfDays: numberOfDays };
    if (this.receiptTypeId == 0)
      delete searchObject['receiptTypeId'];
    if (this.searchTerm == '' || this.searchTerm == undefined) {
      delete searchObject['fieldName'];
      delete searchObject['startsWith'];
    }
    return searchObject;
  }
  constructor(
    private router: Router,
    private receiptService: ReceiptService,
    private toaster: ToastrService,
    private dataTransfer: DataTransferService,
   // private agent: LocalApiConnectorService,
    private http: HttpClient,
    private configs: ConfigService,
    private locationService: LocationService,
    private loader: NgxUiLoaderService,
    private translate: TranslateService) {
    this.pagesContainer = new Array(0);
    this.isSpotter = JSON.parse(sessionStorage.getItem('user')).Network.NetworkId != 1;
  }
  openPaperlessDiv() {
  this.isOpen = !this.isOpen;
  }
  closePaperlessDiv() {
    this.printPaperless = "";
    this.isOpen = false;
  }

  LinkAWB(){ 
    var result:any = null;
    this.receiptService.LinkShipment(this.linkShipments,
      (res) => {
        result = res;
        if(result.isSuccessful){
          alert("Shipment Linked Successfully!");
          if(this.isOpen)
            this.closePaperlessDiv();
        }
        },
      (err) => { 
        console.log(err);
        this.closePaperlessDiv();
       });
   
  }
  

  getData(searchObject) {
    this.receiptService.searchReceipt(searchObject,
      (res) => {
        this.receipts = res.Results;
        this.pageCount = res.Count;
        this.pagesContainer = new Array(Math.ceil(this.pageCount / 10));
        this.receipts.forEach((x) => {
          x.show = false;
        })
      },
      (err) => { console.log(err) });
  }
  newReceipt() {
    if (this.router.url != '/dashboard/cashier/receipts/create') {
      this.dataTransfer.changeMode('default message');
      this.dataTransfer.changeCountry('default message');
      this.dataTransfer.changeProductGroup('default message');
      this.dataTransfer.changeProductType('default message');
      this.router.navigate(['/dashboard/cashier/receipts/create']);
    }

  }

  searchReceipt() {
    this.getData(this.prepareSearchObject(10, this.pagger * 10, this.fieldName, this.searchTerm, this.receiptTypeId, this.isCanceled, 90));
  }

  getSearchPage(pagger) {
    this.pagger = pagger;
    this.getData(this.prepareSearchObject(10, this.pagger * 10, this.fieldName, this.searchTerm, this.receiptTypeId, this.isCanceled, 90));
  }
  prevPage() {
    this.pagger--;
    this.getData(this.prepareSearchObject(10, this.pagger * 10, this.fieldName, this.searchTerm, this.receiptTypeId, this.isCanceled, 90));
  }
  nextPage() {
    this.pagger++;
    this.getData(this.prepareSearchObject(10, this.pagger * 10, this.fieldName, this.searchTerm, this.receiptTypeId, this.isCanceled, 90));
  }

  searchBykeyWord() {
    if (this.searchTerm != undefined && this.searchTerm != null) {
      if (this.searchTerm.length > 2) {
        this.searchReceipt();
      }
      else if (this.searchTerm.length == 0) {
        this.searchReceipt();
      }
    }
  }

  fixDecimals(value: any = 0) {
    if (value != 0 && value != null) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      if (value || value == 0)
        return '0.00';
      else
        return '';
    }
  }

  convertoToDate(date) {
    if (date)
      return moment(date).format('D/MM/YYYY');
    return '-';
  }

  showShipments(index) {
    //to disbale arrow collabe when there is only one shipment
    if (this.receipts[index].Details.length == 1) {
      return false;
    }
    else {
      this.receipts[index].show = !this.receipts[index].show;
    }
  }

  isColVisable(index) {
    try {
      return this.receipts[index].show;
    }
    catch (e) { }
  }

  returnReceiptData(receipt) {
    var receiptShipment = receipt.Details.filter(x => x.Shipment != null);
    if (receiptShipment.length > 0) {
      receiptShipment[0].Shipment.IsCancelled = receiptShipment[0].IsCancelled;
      receiptShipment[0].Shipment.CanBeCancelled = receiptShipment[0].CanBeCancelled;
      return receiptShipment[0].Shipment;
    }
    else {
      return '-';
    }
  }

  cancelShipment(receipt, receiptIndex, shipment, shipmentIndex, category) {
    if (receipt.Details.length > 1 && shipmentIndex == 0 && category == 'main') {
      this.showShipments(receiptIndex);
    }
    else {
      if (shipment[shipmentIndex].Shipment) {
        var shipmentId = shipment[shipmentIndex].Shipment.ShipmentId;
        var receiptsDetails = {
          ReceiptId: receipt.ReceiptId,
          ShipmentId: shipmentId
        };
        this.receiptService.cancelShipment(receiptsDetails, (res) => {
          this.toaster.success(`${this.translate.instant('pages.searchReceipt.shipmentCancelled',{
            shipmentId: shipmentId
          })}`);
        }, (err) => {
          this.toaster.error(`${this.translate.instant('pages.searchReceipt.shipmentNotCancelled')}`);
        });
      }
    }
  }
  hideLoader = true;
  printShipment(receipt, receiptIndex, shipment, shipmentIndex, category) {

    if (receipt.Details.length > 1 && shipmentIndex == 0 && category == 'main') {
      this.showShipments(receiptIndex);
    }
    else {
      if (shipment[shipmentIndex].Shipment) {
        var shipmentId = shipment[shipmentIndex].Shipment.ShipmentId;
        var receiptsDetails = {
          ReceiptId: receipt.ReceiptId,
          ShipmentId: shipmentId
        };
        this.receiptService.printReceiptShipment(receiptsDetails.ReceiptId, receiptsDetails.ShipmentId, (res) => {
          var fileToDownload = res[0].Url;
          var printers = JSON.parse(localStorage.getItem('printingSettings'))
          if (printers != null) {
            var type = 0;
            var copies = 1
            type = printers.CashierOutReport.reportTypeId == res[0].Type.ReportTypeId ? printers.CashierOutReport.printer : 0
            type = printers.ReceiptLabelType.reportTypeId == res[0].Type.ReportTypeId ? printers.ReceiptLabelType.printer : type
            type = printers.TaxReceiptLabelType.reportTypeId == res[0].Type.ReportTypeId ? printers.TaxReceiptLabelType.printer : type
            type = printers.Waybillform.reportTypeId == res[0].Type.ReportTypeId ? printers.Waybillform.printer : type

            copies = printers.CashierOutReport.compies;
            copies = printers.ReceiptLabelType.compies;
            copies = printers.TaxReceiptLabelType.compies;
            copies = printers.Waybillform.compies;
            this.hideLoader = false;
            // this.agent.print(() => {
            //   this.hideLoader = true;
            //   this.toaster.success("Printing process has been started!")

            // }, () => { window.open(fileToDownload, "download") }, {
            //   PrinterName: type,
            //   file: fileToDownload,
            //   copies: copies
            // })
          }
          else {
            window.open(fileToDownload, "download")
          }
        }, (err) => {


        }
        )
      }
    }
  }
  printWaybill(receipt) {
  }

  canCancelShipment(receipt, category, shipment) {
    if (category == 'main') {
      var isOutBoundShipment = receipt.Details.filter(x => x.Type.ReceiptTypeId == 2).length > 0;
      var isOneOfShipmentsCanBeCancelledAndNotCancelled = receipt.Details.filter(x => x.CanBeCancelled == true && x.IsCancelled == false).length > 0;
      return (isOutBoundShipment && this.canCancelOutboundReceipts && isOneOfShipmentsCanBeCancelledAndNotCancelled);
    }
    else if (category == 'sub') {
      return (this.canCancelOutboundReceipts && shipment.CanBeCancelled && !(shipment.IsCancelled) && shipment.Type.ReceiptTypeId == 2)
    }
  }

  canNotCancelShipment(receipt, category, shipment) {
    if (category == 'main') {
      var isOutBoundShipment = receipt.Details.filter(x => x.Type.ReceiptTypeId == 2).length > 0;
      var isOneOfShipmentsCanNotBeCancelledAndIsCancelled = receipt.Details.filter(x => x.CanBeCancelled == false && x.IsCancelled == true).length > 0;
      return (isOutBoundShipment && this.canCancelOutboundReceipts && isOneOfShipmentsCanNotBeCancelledAndIsCancelled);
    }
    else if (category == 'sub') {
      return (this.canCancelOutboundReceipts && !shipment.CanBeCancelled && (shipment.IsCancelled) && shipment.Type.ReceiptTypeId == 2)
    }
  }
  isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    }
    else {
      return false;
    }
  }
  canPrintShipment(receipt, category, shipment) {
    if (!this.isMobile()) {
      if (category == 'main') {
        var canPrintAnyShipment = receipt.Details.filter(x => x.CanBePrinted == true).length > 0;
        return canPrintAnyShipment;
      }
      else if (category == 'sub') {
        return shipment.CanBePrinted;
      }
    }
    else {
      return false;
    }

  }

  canNotPrintShipment(receipt, category, shipment) {
    if (category == 'main') {
      var canNotPrintAnyShipment = receipt.Details.filter(x => x.CanBePrinted == false).length > 0;
      return canNotPrintAnyShipment;
    }
    else if (category == 'sub') {
      return !shipment.CanBePrinted;
    }
  }

  cancelTxt(isCancelled) {
    if (isCancelled)
      return 'Yes';
    else
      return 'No';
  }

  showArrow(receip) {
    var receiptShipment = receip.Details.filter(x => x.Shipment != null);
    if (receiptShipment.length > 0)
      return true;
    else
      return false;
  }
  printReceiptSelected = "selected";
  printWaybillSelected = "";
  printCashoutSelected = "";
  printAll = "";
  printPaperless = "";

  selectThePrintMode(mode, receiptObj: any) {

    this.printAll = ""
    switch (mode) {
      case 1:
        this.printReceiptSelected = this.printReceiptSelected == "" ? "selected" : ""
        this.printWaybillSelected = ""
        this.printCashoutSelected = ""
        this.printAll = ""
        this.printPaperless = "";
        break;
      case 2:
        this.printReceiptSelected = "";
        this.printAll = "";
        this.printCashoutSelected = "";
        this.printPaperless = ""
        this.printWaybillSelected = this.printWaybillSelected == "" ? "selected" : "";
        break;
      case 3:
        this.printReceiptSelected = "";
        this.printAll = "";
        this.printWaybillSelected = ""
        this.printPaperless = ""
        this.printCashoutSelected = this.printCashoutSelected == "" ? "selected" : "";
        break;
      case 4:
        this.printReceiptSelected = ""
        this.printWaybillSelected = ""
        this.printCashoutSelected = ""
        this.printPaperless = ""
        this.printAll = this.printAll == "" ? "selected" : ""
        break;
      case 5:
        this.printReceiptSelected = ""
        this.printWaybillSelected = ""
        this.printCashoutSelected = ""
        this.printAll = ""
        this.printPaperless = this.printPaperless  == "" ? "selected" : ""
        this.openPaperlessDiv();
        break;
    }
  }
  receiptObj: any;
  hideCashout = false;
  printAllLabel = "Receipt + Waybill + Cashout"
  setReceiptObj(receipt, i) {
    this.receiptObj = { receipt: receipt, index: i, details: receipt.Details, shipmentIndex: 0, category: 'main' };
    if (this.receiptObj.receipt.CashOut == null) {
      this.hideCashout = true
      this.printAllLabel = "Receipt + Waybill"
    }
    else {
      this.hideCashout = false
      this.printAllLabel = "Receipt + Waybill + Cashout"
    }

    if(this.isSpotter){
      this.fillAWBNumber(this.receiptObj);
    }
  }

  fillAWBNumber(receiptObj){
    //clear the array
    this.linkShipments = [];
    receiptObj.details.forEach((x) =>{
      var obj = {"CustomerAWB": x.Shipment.Number,"DummyAWB" :""}
      this.linkShipments.push(obj);
    });
   
  }

  newAgentPrint(ReportTypeId, url, newReport = false) {
    this.hideLoader = false
    var _this = this;
    var fileNameIndex = url.lastIndexOf("/") + 1;
    var filename = url.substr(fileNameIndex);
    var temp = "data:application/pdf;base64,";
    this.locationService.getBase64(url, (res) => {
      //this.base64Output = temp.concat(res);
      this.base64Output = res;
      _this.sss.print({
        'documentId': ReportTypeId,
        'fileName': filename,
        'fileData': this.base64Output
         });
    }, (err) => {

    })
  

    // this.http.get(url, { responseType: 'blob' }).subscribe(res => {
    //   var blob = new Blob([res], { type: 'application/pdf' });
    //   const fileURL = URL.createObjectURL(res);
    //   output = this.blobToBase64(blob);
    //   window.open(fileURL, '_blank');
    // });
    
		// _this.sss.print({
		// 'documentId': ReportTypeId,
		// 'fileName': filename,
		// 'fileData': temp
		//  });
     window.open(url, "_blank")
     this.hideLoader = true;
  }

  printSubmit() {

    if (this.printReceiptSelected == "selected") {
      this.receiptService.printWaybillAndReceipt(this.receiptObj.receipt.ReceiptId, (res: any[]) => {

        var printIndex = res.findIndex(x => x.Type.Description == "Receipts")
        let taxRecipt = res.findIndex(x => x.Type.Description == "Tax Invoices")

        setTimeout(() => {
          if (taxRecipt != -1) {
            this.newAgentPrint(res[taxRecipt].Type.ReportTypeId, res[taxRecipt].Url)

          }
        }, 1000)

          this.newAgentPrint(res[printIndex].Type.ReportTypeId, res[printIndex].Url)

      }, (err) => { console.log(err) }, 1)
    }
    else if (this.printWaybillSelected == "selected") {
      
      this.receiptService.printWaybillAndReceipt(this.receiptObj.receipt.ReceiptId, (res) => {

        console.log("res", res);

        //console.log("reporttypeid", res[0].Type.ReportTypeId);

        let otherLabel = res.findIndex(x => x.Type.Description == "Other Labels")
        var printIndex = res.findIndex(x => x.Type.Description == "Labels")

       if(printIndex != -1)
         res[printIndex].Type.ReportTypeId = 1;

       if(otherLabel != -1)
         res[otherLabel].Type.ReportTypeId = 5;

        //console.log("otherLabel", otherLabel)

        setTimeout(() => {
          if (otherLabel != -1) {

            this.newAgentPrint(res[otherLabel].Type.ReportTypeId, res[otherLabel].Url, true)

          }
        }, 1000)

       if(printIndex != -1){
          this.newAgentPrint(res[printIndex].Type.ReportTypeId, res[printIndex].Url)
        }
      }, (err) => { console.log(err) }, 2)

    }
    else if (this.printCashoutSelected == "selected") {
      this.receiptService.printCashout(this.receiptObj.receipt.CashOut.CashOutId, (res) => { this.newAgentPrint(res.Type.ReportTypeId, res.Url) }, (err) => { this.toaster.error(err.error[0].Message) })

    }
    else if (this.printAll == "selected") {
      this.receiptService.printWaybillAndReceipt(this.receiptObj.receipt.ReceiptId, (res) => {
        
        var printWaybillIndex = res.findIndex(x => x.Type.Description == "Labels")
        var printReceipt = res.findIndex(x => x.Type.Description == "Receipts")
        res[printWaybillIndex].Type.ReportTypeId = 1;

        this.newAgentPrint(res[printWaybillIndex].Type.ReportTypeId, res[printWaybillIndex].Url)
        this.newAgentPrint(res[printReceipt].Type.ReportTypeId, res[printReceipt].Url)

      }, (err) => { console.log(err) }, 2)
      if (this.receiptObj.receipt.CashOut != null) {
        this.receiptService.printCashout(this.receiptObj.receipt.CashOut.CashOutId, (res) => { this.newAgentPrint(res.Type.ReportTypeId, res.Url) }, (err) => { this.toaster.error(err.error[0].Message) })
      }
    }
    if(this.isOpen)
     this.closePaperlessDiv();
  }
  ngOnInit() {
    var branchCanCancelOutboundReceipts = JSON.parse(sessionStorage.getItem('branchSettings')).find(m => m.Key == 23).Value == "True";
    this.canCancelOutboundReceipts = JSON.parse(sessionStorage.getItem("user")).Settings.CanCancelOutboundReceipts && branchCanCancelOutboundReceipts;
    this.searchReceipt();

    this.sss = $("#dvamxprint").amxPrintMngr('992ada1b68b34b618173a221393ba8ce',this.configs.getEnviromentId());
    this.sss.start();
    this.sss.result = function (e) {
		  var y = e;
	  };

  }


}
